var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManualHotspot = function SvgManualHotspot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 11,
    r: 2.5,
    stroke: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.062 4.322a.344.344 0 1 1 0 .688H8.884v1.27a.387.387 0 1 1-.773 0V5.01H6.933a.344.344 0 1 1 0-.688h1.178v-1.27a.386.386 0 1 1 .773 0v1.27z"
  })));
};
export default SvgManualHotspot;